export enum ScreenType {
  Tickets = 'VULNS_TICKETS',
  Incidents = 'INCIDENT_TICKETS',
  Entities = 'ENTITIES_EXPLORER',
  AssetView = 'ASSETS_VIEW',
  RiskDashboard = 'RISK',
  RemediationDashboard = 'REMEDIATION',
  ThreatDashboard = 'THREAT_DASHBOARD',
  AssetCoverage = 'ASSET_COVERAGE',
  Alerts = 'ALERTS_VIEW',
  PivotVulnerabilities = 'VULNS_PIVOT',
  PivotIncidents = 'INCIDENT_PIVOT',
  FindingsView = 'FINDINGS_VIEW',
  PolicyViolations = 'POLICY_VIOLATIONS_VIEW',
  ExceptionsView = 'EXCEPTIONS_VIEW',
  PolicyCompliance = 'POLICY_COMPLIANCE',
  AssetInventory = 'ASSET_INVENTORY',
  CoverageAndGap = 'COVERAGE_AND_GAP',
  ViolationTicket = 'VIOLATION_TICKETS',
  IncidentsThreats = 'INCIDENT_THREATS',
  AlertsThreats = 'ALERT_THREATS',
  Clickthrough = 'CLICKTHROUGH',
  TenantsView = 'TENANTS_VIEW',
  UsersView = 'USERS_VIEW',
  IdentityView = 'IDENTITIES_VIEW',
  IdentityFindingsView = 'IDENTITY_FINDINGS_VIEW',
  SourceRuns = 'SOURCE_RUNS',
  IDNPRemediationDashboard = 'IDNP_REMEDIATION_DASHBOARD',
  IDNPOverviewDashboard = 'IDNP_OVERVIEW_DASHBOARD',
  ExposureDashboard = 'EXPOSURE_DASHBOARD',
}

export type ScreenTypeType = (typeof ScreenType)[keyof typeof ScreenType];

export type ViewType = {
  id: string;
  name: string;
  favorite: boolean;
  createdByUserId: string;
  createdAt: string;
  defaultView: boolean;
  accountDefaultView: boolean;
  global: boolean;
  publicView: boolean;
  screenType: ScreenType;
  config: any;
};
